import GVILogoImg from "images/gviIngoLogo.svg";

import GVILogoPeopleImg from "../../../images/gvi_people.svg";

export const getProgramIngoDetails = ({
  programIngo = false,
  journeyProgram = false,
  program,
  featuredIncludesList,
  extraOptions = {},
  additionalCardClass = "sm:h-80 sm:max-h-80 2xl:h-96 2xl:max-h-96",
  runAndLedByGVi,
  runAndLedByFlex
}) => {
  const GVILogo =
    process.env.GATSBY_DEFAULT_THEME === "light"
      ? GVILogoPeopleImg
      : GVILogoImg;

  return {
    containerClass: `relative w-full mb-6 md:mb-10 rounded-md border-2 hover:border-3 flex overflow-hidden sm:h-auto bg-black-lighter planet:bg-transparent border-[#fafafa] planet:border-white hover:border-4 hover:border-yellow-standard hover:shadow-md planet:hover:border-gray-ingo`,
    mainProgramClass:
      "text-mob md:text-base leading-genericCta font-bold md:font-normal text-left sm:min-h-0 sm:h-auto",
    cardClass: `bg-black-lighter planet:bg-transparent sm:flex-row ${additionalCardClass}`,
    programTypeClass: journeyProgram
      ? "xxxs:bg-red-light xxxs:planet:bg-green-standard text-white"
      : "text-white planet:bg-gray-darker",
    runByText: runAndLedByGVi,
    runByTextClass: "text-white",
    ledByNameClass: "planet:text-gray-generic",
    programLogo: GVILogo,
    travelInnerContainerClass:
      "gap-2 sm:px-1 sm:py-3 inline-block bg-transparent",

    travelHeadingClass: `font-normal text-yellow-light planet:text-white`,
    travelDetailsTitle: "text-white",
    travelDetailsDescriptionClass: `font-normal text-yellow-light planet:text-gray-ingoTxt`,
    travelDescriptionClass: "text-yellow-light planet:text-gray-generic",
    programTitleClass: "text-white",
    programContainerClass: "bg-black-lighter planet:md:gvi-dark-gray-bg",
    rightContainerSectionClass: "gap-3 sm:gap-5",
    program: program,
    descWidth: "w-full",
    ctaApplyLabel: "Apply",
    ctaViewLabel: "View program",
    cardClickable: false,
    buttonStyle: "flex w-full",
    isProgramFocusPage: true,
    featuredIncludes: featuredIncludesList,
    itemTextClass: "text-yellow-light",
    durationClass: "text-yellow-light planet:text-gray-generic",
    programIngo,
    priceClass: `text-base  text-white`,
    buttonClassName: `xxs:rounded-none`,
    labelClass: `text-base leading-genericCta font-bold pr-2 text-white planet:text-black-light group-hover:text-black-light planet:group-hover:text-white`,
    arrowClass: `stroke-white hover:stroke-black-lighter group-hover:stroke-black-lighter`,
    ctaViewExtraClass: `w-1/2 sm:w-44 sm:h-[38px] border bg-black-lighter border-white xxxs:hover:bg-white sm:hover:bg-white hover:border-2`,
    ctaViewLabelClass: `pr-2 text-white group-hover:text-black-light`,
    ctaViewArrowClass: "stroke-white group-hover:stroke-black-light",

    ...extraOptions
  };
};
